import {IntermediatePart} from "../../intermediatePart";

export default class CabinetGroup extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'cabinet_group';
    this.partName = 'Cabinet';
    this.translateId = "visualizer.kitchen.cabinet";
    this.canBeDisabled = true;
  }

}
